import { render } from "./AddOrEditSpecialProject.vue?vue&type=template&id=75626305&ts=true"
import script from "./AddOrEditSpecialProject.vue?vue&type=script&lang=ts"
export * from "./AddOrEditSpecialProject.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__